import { WifiOff } from 'lucide-react'
import { useEffect, useState } from 'react'

/**
 * Sticky banner shown while navigator.onLine === false. Renders at the top
 * of the viewport so the user immediately sees why recent actions failed.
 * SSR-safe: first paint assumes online, which is a safe default.
 */
export function OfflineBanner() {
  const online = useOnlineStatus()
  if (online) return null
  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-50 flex items-center justify-center gap-2 bg-destructive px-4 py-2 text-sm font-medium text-destructive-foreground shadow-sm"
    >
      <WifiOff className="h-4 w-4" aria-hidden="true" />
      Нет интернета. Проверьте соединение — мы повторим запрос автоматически.
    </div>
  )
}

function useOnlineStatus(): boolean {
  // Инициализируем true для SSR и первого рендера в dev — navigator.onLine
  // недоступен до hydration.
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  )
  useEffect(() => {
    const update = () => setOnline(navigator.onLine)
    window.addEventListener('online', update)
    window.addEventListener('offline', update)
    // Синхронизируем стартовое состояние — между первым рендером и mount'ом
    // соединение могло уже упасть.
    update()
    return () => {
      window.removeEventListener('online', update)
      window.removeEventListener('offline', update)
    }
  }, [])
  return online
}
